export default __webpack_public_path__ + "static/media/vision-mission.ca0d309a.png";